import axios from 'axios'
import { cacheClear } from './memoryCache'
import { getUserCachedData } from './UserAuthorization'
import { buildApiUrl } from 'config/environment'
import { observarCarregamento } from './carregamentoGlobal'

let sessionExpirationHandled = false

export const resetSessionExpirationHandling = () => {
  sessionExpirationHandled = false
}

export const attachSessionInterceptor = client => {
  client.interceptors.response.use(
    response => response,
    error => {
      const hasActiveSession = Boolean(getUserCachedData()?.token)
      const sessionExpired = error?.response?.status === 401 && hasActiveSession

      if (sessionExpired && !sessionExpirationHandled) {
        sessionExpirationHandled = true
        localStorage.removeItem('user')
        cacheClear()

        window.dispatchEvent(new CustomEvent('session-expired'))
      }

      if (error?.response?.status === 402 || (error?.response?.status === 403 && String(error?.response?.data?.error || '').toLowerCase().includes('bloqueada'))) {
        window.dispatchEvent(new CustomEvent('company-blocked', {
          detail: error?.response?.data?.error || 'Acesso suspenso por pendência financeira.'
        }))
      }

      return Promise.reject(error)
    }
  )

  return client
}

export const createApiClient = config => observarCarregamento(attachSessionInterceptor(axios.create(config)))

export const createServiceClient = path => createApiClient({
  baseURL: buildApiUrl(path),
})
